import React, {  useContext, useRef, useState } from 'react'
import '../Pages/CSS/LoginSignup.css'
import { ShopContext } from '../Context/ShopContext';
import { toast } from 'react-toastify';

const LoginSignup = () => {
  const [log_sign, setlog_sign] = useState("Login");
  const {url}=useContext(ShopContext);
  let agr=useRef();
  const [input_data, setinput_data] = useState({
    user_name: "",
    email: "",
    password: ""
  });

  const handle_input_data = (e) => {
    setinput_data({ ...input_data, [e.target.name]: e.target.value })
  }


  const login_function=async ()=>{
    if(agr.current.checked!==true){
      toast.error("Agreement is compulsary !");
      return;
    }
    let respone_data;
   try {
     await fetch(`${url}/login`,{
       method:'POST',
       headers:{
         Accept:"application/form-data",
         "Content-Type":"application/json"
       },
       body:JSON.stringify(input_data),
      }).then((resp)=>resp.json()).then((data)=>respone_data=data);
  
      if(respone_data.success){
       localStorage.setItem("auth-token",respone_data.token);
       window.location.replace("/");
       toast.success("Login Succefully")
      }else{
       toast.error(respone_data.errors)
      }
   } catch (error) {
    toast.error("sorry server is down please login ofter some time!")
   }
   
  }


  const signup_function= async ()=>{
    if(agr.current.checked!==true){
      toast.error("Agreement is compulsary !");
      return;
    }
    let respone_data;
   try {
    await fetch(`${url}/signup`,{
      method:'POST',
      headers:{
        Accept:"application/form-data",
        "Content-Type":"application/json"
      },
      body:JSON.stringify(input_data),
     }).then((resp)=>resp.json()).then((data)=>respone_data=data);
     
     if(respone_data.success){
      localStorage.setItem("auth-token",respone_data.token);
      // window.location.replace("/");
      toast.success("Successfully Registered!")
      toast.info("Press Continue to login");
      setlog_sign("Login")
    }else{
      toast.error(respone_data.errors)
     }
   } catch (error) {
    toast.error("sorry server is down please signup ofter some time");  
   }

  }
  return (
    <div className='loginsignup'>
      <div className="loginsignup-container">
        <h1>{log_sign}</h1>
        <div className="loginsignup-field">
          {log_sign === "Sign Up" ? <input type="text" name="user_name" placeholder='Your Name' value={input_data.user_name} onChange={handle_input_data} /> : <></>}
          <input type="email" name="email" placeholder='Email' value={input_data.email} onChange={handle_input_data} />
          <input type="password" name="password" placeholder='Password' value={input_data.password} onChange={handle_input_data} />
        </div>
        <button onClick={() => {
          {log_sign==="Sign Up"?signup_function():login_function()}
        }}>Continue</button>
        {log_sign === "Sign Up" ? <p className='loginsignup-login'>Already have an Account? <span onClick={() => {
          setlog_sign("Login")
        }}>Login here</span></p> : <></>}
        {log_sign === "Login" ? <p className='loginsignup-login'>Create an Account? <span onClick={() => {
          setlog_sign("Sign Up")
        }}>Click here</span></p> : <></>}
        <div className="loginsignup-agree">
          <input type="checkbox" ref={agr} style={{cursor:"pointer"}}/>
          <p>By Continuing I agree to the term & policy. </p>
        </div>

      </div>
    </div>
  )
}

export default LoginSignup
